export default "__VITE_PUBLIC_ASSET__eb2c9c46__"